/**
 * Validate a `returnUrl` query param value before passing it to the router.
 *
 * Only same-origin paths are accepted: the value must start with a single `/`
 * and must NOT start with `//` (which the URL parser treats as protocol-relative
 * and would let an attacker redirect to an external host like `//evil.com/x`).
 *
 * Anything else falls back to the default backoffice landing.
 */
export const DEFAULT_RETURN_URL = '/backoffice';

export function safeReturnUrl(raw: string | null | undefined): string {
    if (!raw) return DEFAULT_RETURN_URL;
    if (!raw.startsWith('/')) return DEFAULT_RETURN_URL;
    if (raw.startsWith('//')) return DEFAULT_RETURN_URL;
    return raw;
}
